import type { CustomNode } from '../../../components/custom-nodes/types';
import type { DragEvent } from 'react';
import type { ReactFlowInstance } from 'reactflow';

interface GetHoveredNodeProps {
  nodes: CustomNode[];
  event: DragEvent<HTMLDivElement>;
  reactFlowInstance?: ReactFlowInstance;
}
export const getHoveredNode = ({ nodes, event, reactFlowInstance }: GetHoveredNodeProps) => {
  const placeholderNode = nodes.find((node: CustomNode) => {
    const nodeBounds = {
      top: node.position.y,
      bottom: node.position.y + (node.height ?? 0),
      left: node.position.x,
      right: node.position.x + (node.width ?? 0),
    };
    const mousePosition = reactFlowInstance?.screenToFlowPosition({
      x: event.clientX,
      y: event.clientY,
    });
    if (!mousePosition) {
      return null;
    }

    return (
      mousePosition.x > nodeBounds.left &&
      mousePosition.x < nodeBounds.right &&
      mousePosition.y > nodeBounds.top &&
      mousePosition.y < nodeBounds.bottom
    );
  });

  return placeholderNode;
}
